p<template>
    <div class="main-app mt-12" style="background-color:#e7e7e7 !important;">

        <div>

            <v-container v-if="favorite_rms_checked_list&&favorite_rms_checked_list.length>0" class="container-600 pt-0">

                <div id="properties_w8_payment" class="mb-12 pb-10">
                    <div class='row'>
                        <div class="col-12 pt-0">

                            <v-container
                                    v-for="(item, i) in favorite_rms_checked_list"
                                    :key="i"
                                    class="pa-0"
                            >
                                <h4 class="mb-2 mt-5 text-lpn">
                                    {{ item.project_name_th }}
                                </h4>

                                <v-card flat class="mx-auto">

                                    <div style="position: relative;">
                                        <div class="d-flex">
                                            <div class="col-5" :style="'border-left: 5px solid'+getProjectColor(item.project_shortname)+';background:#f2f2f2;'+(!item.rms_avialable_status ? 'opacity:0.5;':'')">
                                                <div class="d-flex flex-column  justify-space-between text-detail-color" style="height: 100%;">
                                                    <div class="font-weight-bold" style="font-size: 1.25em;">{{item.property_unit_code}}</div>
                                                    <div style="line-height: 1em">
                                                        <span class="mr-3" style="font-size: 1em;"></span>
                                                        <div class="mt-2" style="font-size: 0.85em;">{{item.unit_type_name_th}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-7 pa-0">
                                                <div :style="'background-image: linear-gradient(to bottom left,'+(item.available_status ? 'rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.4)':'rgba(166,177,173, 0.8),rgba(166,177,173, 0.8)')+'),url(\''+(item.hasOwnProperty('prop_image_link')&&item.prop_image_link ? item.prop_image_link:require('@/assets/images/no_image_available.jpeg'))+'\');background-repeat: no-repeat;background-size: 100% 100%, cover;background-position: center;'">
                                                    <img
                                                            class="white--text align-end"
                                                            :src="(item.hasOwnProperty('prop_image_link')&&item.prop_image_link ? item.prop_image_link:require('@/assets/images/no_image_available.jpeg'))"
                                                            style="visibility: hidden;width: 100%;"
                                                    />

                                                    <div class="d-flex flex-column font-weight-bold" style="position: absolute;bottom: 10px;right:10px;z-index: 1;border: 1px solid #fff;opacity: 0.75;">
                                                        <div class="white text-center pa-1">
                                                            <span class="text-lpn" style="font-size:0.75em;">
                                                                {{item.property_area | formatNumber2Digit}}
                                                            </span>
                                                        </div>
                                                        <div class="text-center py-0 ma-0">
                                                            <span class="white--text" style="font-size: 0.65em">
<!--                                                            <span class="black&#45;&#45;text" style="font-size: 0.65em">-->
<!--                                                                {{ item.property_type_code=='CONDO' ? 'ตร.ม.':'ตร.ว.' }}-->
                                                                ตร.ม.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!item.rms_avialable_status" class="sold text-center" style="position: absolute;top:35%;width: 100%;opacity: 0.65;z-index: 2">
                                            <div class="pa-5 red white--text" style="margin: -20px auto;width: 60%;">ขออภัยค่ะ รายการถูกจองไปก่อนหน้านี้แล้ว</div>
                                        </div>
                                    </div>
                                    <v-card-text :class="'subtitle-1 px-5 py-2 '+(!item.rms_avialable_status ? 'grey--text':'text-detail-color')">

                                        <div v-if="parseFloat(item.price_total_amount)>0&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')" class="row row--dense font-weight-bold" style="font-size: 1.1em;">
                                            <div v-if="parseFloat(item.price_total_amount)>0&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')" class="col-6 my-0 py-0 text-left">ราคา</div>
                                            <div v-if="parseFloat(item.price_total_amount)>0&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')" class="col-6 my-0 py-0 text-right">
                                                <span class="">{{parseFloat(item.price_total_amount)  | formatNumber}}</span> บาท
                                            </div>

                                            <div v-if="parseFloat(item.price_total_amount)>0&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')" class="col-6 my-0 py-0 text-left font-weight-regular">เงินจอง</div>
                                            <div v-if="parseFloat(item.price_total_amount)>0&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')" class="col-6 my-0 py-0 text-right font-weight-regular">
                                                <span class="">{{item.pp_prop_deposit_amount | formatNumber}}</span> บาท
                                            </div>
                                            <div class="col-12 mt-2 d-flex justify-space-between">
                                                <div class="text-center">
                                                    <v-btn tile block small elevation="0"
                                                           @click="removeFavorite(item)"
                                                           color="#f0f0f0"
                                                    >
                                                        <span class="red--text" style="font-size: 0.85em;"><v-icon color="red" small left>mdi-close</v-icon>ไม่สนใจ</span>
                                                    </v-btn>
                                                </div>
                                                <div v-if="(item.hasOwnProperty('project_is_open_for_sale')&&item.project_is_open_for_sale=='Y')&&(item.hasOwnProperty('property_is_open_for_sale')&&item.property_is_open_for_sale=='Y')">
                                                    <v-btn
                                                            v-if="(item.rms_avialable_status ? true:false)"
                                                            :color="(cartItemFind(item) ? getProjectColor(item.project_shortname):'')"
                                                            block
                                                            elevation="0"
                                                            :outlined="(cartItemFind(item) ? false:true)"
                                                            :disabled="(item.rms_avialable_status ? false:true)"
                                                            :class="(cartItemFind(item) ? getProjectColor(item.project_shortname,'text_color_class'):'black--text')"
                                                            style="height: 28px;"
                                                            @click="addCartItem(item)"
                                                    >
                                                        <v-icon left small>
                                                            {{(cartItemFind(item) ? 'mdi-check':'mdi-cart-outline')}}
                                                        </v-icon>
                                                        {{(cartItemFind(item) ? 'เลือกแล้ว':'เลือกจองห้องนี้')}}

                                                    </v-btn>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-container>

                            <v-row class="ma-0 mt-3 py-1 bg-lpn white--text" style="border: 1px solid #ccc;" v-if="(favorite_rms_checked_list&&(count_available_unit>0))">
                                <v-col class="pa-0 col-6">
                                    <div class="text-left d-flex flex-column justify-space-between" style="font-weight:bold; font-size: 1em;width: 100%; height: 100%;">
                                        <div class="px-2 text-center" style="width: 100%;">เครดิตของคุณ</div>
<!--                                        <div class="pa-2 pb-0">-->
<!--                                            <v-btn @click="gotoRoute('https://liff.line.me/1654257794-yPbVXYj4',{external_link:1,newtab:1})" small color="orange lighten-3" block>-->
<!--                                                <v-icon small left >mdi-cart</v-icon> ซื้อเครดิต-->
<!--                                            </v-btn>-->
<!--                                        </div>-->
                                    </div>
                                </v-col>
                                <v-col class="pa-0 col-6">
                                    <div class="text-right white lighten-4 text-lpn mr-1 d-flex align-center justify-end" style="font-weight:bold; font-size: 0.95em; padding: 5px;border-radius: 5px;height: 100%;">
                                        <span :class="(credit_point==0 ? 'red--text':'black--text')+' mr-2'">
                                            {{credit_point}}
                                            <span class="blue-grey--text ml-2" style="font-size: 0.85rem">(มูลค่า {{ credit_amount | formatNumber }} บาท)</span>
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>

                        </div>

<!--                        <div class="col-12 save_cart2">-->
<!--                            <v-btn block :disabled="!(favorite_rms_checked_list&&(count_available_unit==favorite_rms_checked_list.length))" class="bg-lpn">-->
<!--                                <span class="white&#45;&#45;text" style=""><v-icon small left color="white">mdi-cart</v-icon> ยืนยันการจอง / ชำระเงิน</span>-->
<!--                            </v-btn>-->
<!--                        </div>-->

                    </div>
                </div>
            </v-container>
            <v-container v-else>
                <v-layout wrap align-center justify-center>
                    <v-flex xs12 sm12 md12 style="text-align: left" class="mt-4 text-center grey--text">
                        <div><v-icon x-large color="#ccc">mdi-star</v-icon></div>
                        <div>ท่านยังไม่มีข้อมูลห้องที่สนใจ</div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <!-- แสดงห้องที่ user เลือก -->
        <selected-properties-tool-bar  ref="selected_properties" v-bind="{cart_item:current_cart_item}"></selected-properties-tool-bar>

    </div>
</template>

<script>
    import SelectedPropertiesToolBar from '@/components/saleOnline/SelectedPropertiesToolBar'

    export default {
        name: "MyFavoriteUnit",
        components: {
            selectedPropertiesToolBar: SelectedPropertiesToolBar,
        },
        data(){
            return{
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                customer_profile:{},
                favorite_list:[],
                favorite_rms_checked_list:[],
                credit_amount:"",
                credit_point:"",
                username:null,
                count_available_unit:0
            }
        },
        async mounted(){
            window.scrollTo(0,0)
            // check auth login with LINE is valid
            this.customer_profile = this.getSavedLocalItem(this.local_customer_key)
            if (!this.customer_profile) {
                return this.logout()
            }

        },
        async created() {

            //แสดงเลข version
            store.commit('changeShowVersionState', false)

            //แสดงเมนูด้านล่าง และกำหนดรายการเมนู
            this.setBottomNav(true,[],'sale_online')

            this.setTopNav(
                true,
                'รายการห้องที่สนใจ',
                '',
                    '',
                '',
                '',
                ''
            )

            //แสดง loading
            this.current_loading_state.show = true
            store.commit('changeLoadingState', this.current_loading_state)

            this.favorite_list = await this.getFavoriteList()
            this.favorite_rms_checked_list = await this.favoriteListRmsChecked(this.favorite_list)

            this.myCredit = await this.getCredit()

            //ซ่อน loading
            this.current_loading_state.show = false
            store.commit('changeLoadingState', this.current_loading_state)

            //console.log(this.favorite_list)
            //console.log(this.favorite_rms_checked_list)
            //console.log(this.myCredit)

            //ซ่อน flash massage
            store.commit('changeFlashState',{show:false})
        },
        computed: {
            // calTotalAmount(){
            //     let pp_total_amount=0
            //     this.favorite_rms_checked_list.forEach((value, key) => {
            //         pp_total_amount += parseFloat(value.pp_prop_deposit_amount)
            //     })
            //     return pp_total_amount
            // }
        },
        methods:{
            async removeFavorite(properties){
                if (await this.$root.$confirm.open('คำเตือน', 'คุณต้องการยกเลิกจองห้อง '+properties.property_unit_code+' '+properties.project_name_th+' ใช่หรือไม่?', { color: 'red',only_agree:false })) {
                    //แสดง loading
                    this.current_loading_state.show = true
                    store.commit('changeLoadingState', this.current_loading_state)

                    let fav = 'N'

                    await this.saveFavorite(properties.property_id, fav)

                    //update favorite total notification in main menu
                    let total_favorite = await this.getFavoriteSummary()
                    if (total_favorite && total_favorite.hasOwnProperty('count_favorite') && parseInt(total_favorite.count_favorite) > 0) {
                        this.updateNotification('favorite', total_favorite.count_favorite)
                    }else{
                        this.updateNotification('favorite', 0)
                    }
                    this.setBottomNav(true, [], 'sale_online')

                    this.favorite_list = await this.getFavoriteList()
                    this.favorite_rms_checked_list = await this.favoriteListRmsChecked(this.favorite_list)

                    //ซ่อน loading
                    this.current_loading_state.show = false
                    store.commit('changeLoadingState', this.current_loading_state)
                }
            },
            async getFavoriteList(){
                const cs_profile = this.getSavedLocalItem(this.local_customer_key)

                const requestBody = {
                    username: cs_profile.CR_LINE_ID,
                    user_id:this.getAppUserId(),
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getFavoriteDetail', requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
           async getCredit(){

                const cs_profile = this.getSavedLocalItem(this.local_customer_key)

                const requestBody = {
                    lineId: cs_profile.CR_LINE_ID,//'Ueb87cd2cd95a323c57752a668b673f3f',
                    chId:cs_profile.LL_CH_ID,//"1654142033",
                    eventId:this.getSavedLocalItem(this.local_setting_key) ? (this.getSavedLocalItem(this.local_setting_key).event_id ? this.getSavedLocalItem(this.local_setting_key).event_id :"1"):"1"
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('saleEvent/getDataInfo', requestBody,false,'json','U2FsZUV2ZW50I010aTV6Yjg0OmtZZEBqNDBtJHpmITguNA=='))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.res.data.status=='ok') {
                        finalResult = {...promiseChecking.result.res.data.result}
                        if(finalResult) {
                            this.credit_amount = finalResult.amount_per_credit ? finalResult.amount_per_credit*finalResult.credit_point:0
                            this.credit_point = finalResult.credit_point
                        }
                    }
                }
                return this.myCredit
            },
            favoriteListRmsChecked(item){
                let tmp_item = []
                item.forEach((value, key) => {
                    value.PD_RUNNO = value.PD_RUNNO ? value.PD_RUNNO : value.pd_runno
                    this.checkRmsStatus(value.PD_RUNNO).then((rms_checked_result) => {
                        if(rms_checked_result){
                            this.count_available_unit+=1
                        }
                        // console.log(rms_checked_result)
                        value.rms_avialable_status = rms_checked_result
                        value.available_status = rms_checked_result
                        if(value.hasOwnProperty('is_favorite')) {
                            value.is_favorite = 'Y'
                        }
                        tmp_item.push(value)
                        // console.log('available',rms_checked_result)
                    })
                })

                // console.log('result',tmp_item)
                return tmp_item
            },
            async checkRmsStatus (pd_runno) {
                const requestBody = {
                    ref2:pd_runno
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/rms/statusByProject', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = {...promiseChecking.result.res.data.result}
                    }
                }

                let status = false
                if(finalResult) {
                    if(finalResult.status=='W'){
                        status = true
                    }else if(finalResult.status=='L'){
                        status = false
                    }else if(finalResult.status=='C') {
                        status = false
                    }else{
                        status = false
                    }
                }

                return status
                // return false
            },
        }

    }
</script>

<style scoped>
    .save_cart{
        position: fixed;
        bottom: 56px;
        left:0;
        width: 100%;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background-color: #f0f0f0;
        padding: 0;
        box-shadow: 1px 1px 5px #555;
    }

    .save_cart2{
        position: fixed;
        bottom: 56px;
        left:0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background-color: #e9e9e9;
        padding: 0 10px 10px 10px;
        /*box-shadow: 1px 1px 5px #555;*/
    }
    .save_cart2:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 50px;
        top: -50px;
        left: 0;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#e7e7e7), to(#e7e7e7));
        background-image: linear-gradient(rgba(233, 233, 233, 0), #e7e7e7);
    }

    .remove_item{
        position: absolute;
        right: -8px;
        top:-8px;
        cursor: pointer;
    }
    .remove_item:hover{
        color:red;
    }

    .text-detail-color{
        color:#595a5c;
    }
</style>
